<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">To Renee Ann Benally</p>
<p class="subsq dedication-content">You are gone but not forgotten.</p>
<p class="subsq dedication-content">Your family is forever in NK Tribe Called Success’ prayers.</p>
<p class="subsq dedication-content">.</p>
<p class="subsq dedication-content">To my Native American brothers and sisters, we are kindred spirits.  My book was released during the month of November, which is also Native American Heritage Month.  What a fitting way to bring attention to the growing plight of homelessness in the indigenous community.  Together we can develop viable solutions to reaffirm our humanity.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5bfcb538